import { render, staticRenderFns } from "./actionsField.vue?vue&type=template&id=5ac82c52&"
import script from "./actionsField.vue?vue&type=script&lang=js&"
export * from "./actionsField.vue?vue&type=script&lang=js&"
import style0 from "./actionsField.vue?vue&type=style&index=0&id=5ac82c52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports